module.exports = __webpack_public_path__ + "img/eprice-button-red-02.ee923c5d.png";